import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore } from 'redux-persist';

import combinedReducer from './reducer';

export const history = createHistory();
const navMiddleware = routerMiddleware(history);

const store = createStore(
    combinedReducer,
    composeWithDevTools(
      applyMiddleware(
        thunk,
        navMiddleware,
      )
    )
  );

export const makePersist = (callback) => persistStore(store, null, callback);

/*export*/// const persistor = persistStore(store);

export default store;
